<template>
  <div class="print-model">
    <div id="printMe" ref="printMe" v-if="!loading">
      <SalesPayments :item="item" />
    </div>
  </div>
</template>
<script>
import SalesPayments from './components/salesPayments.vue'
export default {
  data() {
    return {
      path: '/salespayments',
      logo: localStorage.getItem('logo'),
      item: {},
      loading: true
    }
  },
  methods: {
    getitem() {
      this.item = this.$parent.printedSalesPayment
      this.loading = false
      var myel = this
      setTimeout(function () {
        var text = document.getElementById('printMe').innerHTML
        document.getElementById('printMe').remove()
        var myframe = document.getElementById('inviceIframe')
        myframe.contentDocument.body.innerHTML = text
        myframe.contentDocument.body.classList.add('payment-style')
        setTimeout(function () {
          myframe.focus()
          myframe.contentWindow.print()
          myel.colse()
        }, 100)
      }, 20)
    },
    colse() {
      this.$parent.printedSalesPayment = false
    }
  },
  mounted() {
    this.getitem()
  },
  components: {
    SalesPayments
  },
  props: ['options']
}
</script>
